// Autogenerated using https://gitlab.myteksi.net/grab-x/x-commons/
// Script facets/codeGen.sh version: 0.0.1
// Please use this script to update facets and auto generate relevant code
const predefinedFacetsMap = {
  ApplicationID: "aid", // The (mobile) application package name (android, ios)
  AppVersion: "avn", // The app version number (android, ios)
  BookingBatch: "bbc", // The booking batch id
  BookingCode: "bkg", // The booking code (android, ios)
  City: "city", // The city identifier (ios)
  Carrier: "crn", // The device telecommunication provider (android, ios)
  ClientIP: "clientIP", // The client IP address
  Country: "ctry", // The country code (ios)
  Driver: "dax", // The driver identifier
  DeviceLanguage: "dla", // The device language setting (ios)
  DropoffLocation: "dol", // Drop off location in lat,long format
  DeviceLocale: "dlc", // The device locale setting (android, ios)
  Domain: "dom", // The domain/namespace (ios)
  Device: "dvc", // The device identifier (android)
  DeviceID: "dvi", // The device identifier (android, ios)
  DeviceBrand: "dvn", // The device brand (android, ios)
  DeviceModel: "dvm", // The device model (android, ios)
  DeviceRAM: "dvr", // The device RAM (android, ios)
  DeviceScreenFactor: "dsf", // The device screen factor (android, ios)
  Error: "err", // The error message (ios)
  EType: "etype", // RESERVED: The type of event (rollout, experiment, track)
  Experiment: "exp", // RESERVED: The name of the experiment (ios)
  FoodBusinessType: "fbt", // The food business type (food, mart)
  FoodOrderType: "fot", // The food order type (integrate ...)
  Host: "host", // The host name (ios)
  ID: "id", // The custom identifier (ios)
  IPAddress: "ip", // The IP  address (for chaos testing) (ios)
  LanguageCode: "lan", // The language code
  LocationGranted: "lgt", // ?? (ios)
  Locale: "lng", // The device locale setting (android)
  Location: "loc", // The location (coordinates in {lat,lng} format) (android, ios)
  UserDefinedLocation: "udl", // The custom location (coordinates in {lat,lng} format) (android, ios)
  Log: "log", // The log message (android, ios)
  LogLevel: "lvl", // The log level (android, ios)
  TaxiVehicle: "tex", // Taxi vehicle identifier
  VehiclePlate: "vhp", // The Lavender only taxi plate facet
  Merchant: "mex", // The merchant identifier
  MexUser: "meu", // The merchant end user
  MexStore: "mes", // The merchant store ID
  MobileCountryCode: "mcc", // The Mobile Country Code e.g. 525 - Singapore
  Network: "net", // The device network provider (android)
  NetworkType: "nwt", // The device network type (android, ios)
  OsType: "ost", // The OS type including iOS or Android (android)
  OsVersion: "osv", // The OS version (android, ios)
  Passenger: "pax", // The passenger identifier
  PatronusID: "patid", // The unique device ID for onboarding user before authentication
  PublicUserID: "pid", // The public user iD (e.g. safe ID) (android, ios)
  ServiceUserID: "sui", // The service user iD except for pax and dax (e.g. merchant user ID, Grab Wheels user ID)
  Prefix: "pre", // RESERVED: The prefix override (ios)
  Request: "req", // The request identifier (ios)
  Region: "reg", // The region identifier. e.g. APAC, ALL
  ScreenResolution: "res", // The screen resolution of the mobile device (android, android)
  ScriptValue: "script", // RESERVED: The script value facet
  Segment: "seg", // The custom facet to segment the population by (android, ios)
  Series: "ser", // The pricing series identifier (ios)
  Session: "sid", // The session identifier (android, ios)
  SampleRate: "sr", // RESERVED: The sampling rate (ios)
  Source: "src", // The source of an event Pax/Dax
  ScribeSDKVersion: "ssv", // Scribe SDK version (android, ios)
  DevelopmentStage: "stage", // Development stage (android, ios)
  Build: "build", // Build of the app, mainly for distinguish google(gms) and Huawei(hms) builds (android)
  StringValue: "sval", // RESERVED: The string value facet
  VehicleTypeID: "svc", // Referred to in the Scribe SDK as service (android, ios)
  Tag: "tag", // The tag representing some additional info (android, ios)
  Token: "tkn", // The token for authentication
  Telco: "tlc", // The device telecommunication provider (android)
  Timestamp: "ts", // RESERVED: The timestamp facet (ios)
  TimeIngested: "tsi", // RESERVED: The time when we received the event.
  TimeIngestedKafka: "tsk", // RESERVED: The time when the event was ingested in kafka
  TimeConsumedKafka: "tkc", // RESERVED: The time when the event was consumed from kafka
  EventType: "typ", // Event Type (android, ios)
  EventID: "uuid", // RESERVED: The event ID is a unique event ID.
  Value: "val", // RESERVED: The value facet (double) (android, ios)
  AdditionalDropLocations: "adl", // Additional drop locations json([lat,long, lat2,long2]) format
  LocationGeohash: "lgh", // Location Geohash
  Batch: "bch", // RESERVED: The event batch identifier
  VariantID: "vrt", // RESERVED: Indicates which experiment choice or rollout target the value comes from
  Treatment: "trt", // RESERVED: Indicates experiment treatment index (useful to identify synced variants across multiple variables in the same experiment)
  StatsBatchID: "sbi", // RESERVED: It will be used to track the bch of event in the stats events.
  StatsEventSource: "ses", // RESERVED: It is used to track the source of the event in the stats events. This will help to group by services in stats calculation.
  ScribeSDKType: "sst", // RESERVED: It is used to store that which type of SDK the event came from. mobile/web/backend
  Kudo: "kudo", // RESERVED: Kudo user identifier
  PartnerID: "parid", // RESERVED: Unique identifier of our partners
  PartitionKey: "partkey", // Partition key
  MexMerchant: "mem", // Tne hierarchy above merchant outlet, one mem can have multiple outlets
  Group: "grp", // RESERVED: Name of the group
  // Browser specific facets
  BrowserType: "bst", // RESERVED: It is used to store the browser type from request header
  BrowserVersion: "bsv", // RESERVED: It is used to store the browser version from request header
  PageTitle: "title", // Page Title of the browser tab
  URLPath: "path", // Path of the url on which event happened excluding hostname
  PageLocation: "lct", // Full URL of the page
};

export { predefinedFacetsMap };
